<template>
  <div>
    <login v-if="!uId"/>
    <div v-else>
      <admin-nav/>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import Login from '@/components/Admin/Login';
  import AdminNav from '@/components/Items/AdminNav';
  export default {
    name: "Admin",
    components: {Login, AdminNav},
    computed: {
      ...mapState('auth', ['uId'])
    },
    methods: {
      ...mapActions('auth', ['getUid']),
    },
  }
</script>

<style scoped>

</style>